<h2 class="no-margin-bottom float-left">Rules Editor</h2>

@if (!isButtonRule) {
  <div id="flowRulesEditorTop">
    <button class="button hollow float-right" (click)="startFormRule()">Add Rule</button>
    <hr />
    <h3>Rules Added:</h3>
    @if (existingRules.length) {
      <section class="ruleScrollContainer">
        <ul class="no-bullet">
          @for (rule of existingRules; track rule) {
            <li [ngClass]="{'selectedRule' : selectedRule == rule }">
              <span>{{rule.name}}</span>
              <button title="Edit Rule" (click)="editRule(rule)" attr.aria-label="Edit Rule {{rule.name}}">
                <svg-icon icon="icon-pencil" class="tiny" [ngClass]="{'white' : selectedRule == rule}" aria-hidden="true"></svg-icon>
              </button>
              <button title="Delete Rule" attr.aria-label="Delete Rule {{rule.name}}" (click)="confirmDelete(rule, true)">
                <svg-icon icon="icon-trash" class="tiny" [ngClass]="{'white' : selectedRule == rule}" aria-hidden="true"></svg-icon>
              </button>
            </li>
          }
        </ul>
      </section>
    }
    @if (editActive) {
      <section id="newRuleEditor">
        <hr />
        <h4>Editing Rule: {{ruleName}}</h4>
        <div>
          <label>
            <span class="label-text required">Rule Name:</span>
            <input type="text" id="txtbxRuleName" placeholder="Name" [(ngModel)]="ruleName" />
          </label>
        </div>
        <div>
          <label>
            <span class="label-text">Apply Rule:</span>
            <select id="slctRuleApplication" (ngModelChange)="updateTrigger($event)" [(ngModel)]="selectedTriggerOption">
              @for (trigger of ruleTriggerOptions; track trigger) {
                <option [value]="trigger.id">{{trigger.text}}</option>
              }
            </select>
          </label>
        </div>
        <div>
          @switch (selectedTriggerOption) {
            @case (0) {
              <p id="slctWatchInputContainer">Use the "Clipboard" icons at the left to select the question the rule will watch.</p>
            }
            @case (1) {
              <div id="slctWatchPageContainer">
                <label>
                  <span class="label-text">Select Section:</span>
                  <select id="slctWatchSection" (ngModelChange)="changeTargetSection($event)" [(ngModel)]="triggerSection">
                    @for (section of availableSections; track section; let i = $index) {
                      <option [ngValue]="section">{{getSectionTitle(i, section)}}</option>
                    }
                  </select>
                  <span class="label-text">Select Page:</span>
                  <select id="slctWatchPage" [(ngModel)]="triggerPage">
                    @for (page of availablePages; track page) {
                      <option [ngValue]="page">{{getPageTitle(page)}}</option>
                    }
                  </select>
                </label>
              </div>
            }
            @case (2) {
              <div id="slctWatchStateContainer">
                <span class="label-text">Select Form:</span>
                <select id="slctWatchState" [(ngModel)]="selectedTransition">
                  @for (transition of availableTransitions; track transition) {
                    <option [ngValue]="transition">{{transition.name}}</option>
                  }
                </select>
              </div>
            }
          }
        </div>
      </section>
    }
  </div>
}

@if (isButtonRule) {
  <div id="buttonRulesEditorTop">
    <button class="button hollow float-right" (click)="startButtonRule()">Add Rule</button><span>{{buttonError}}</span>
    <hr />
    <h3>Rules Added:</h3>
    @if (existingRules.length) {
      <section class="ruleScrollContainer">
        <ul class="no-bullet">
          @for (rule of existingRules; track rule) {
            <li [ngClass]="{'selectedRule' : selectedRule == rule}">
              <span>{{rule.name}}</span>
              <button title="Edit Rule" (click)="editButtonRule(rule)" attr.aria-label="Edit Rule {{rule.name}}">
                <svg-icon icon="icon-pencil" class="tiny" [ngClass]="{'white' : selectedRule == rule}" aria-hidden="true"></svg-icon>
              </button>
              <button title="Delete Rule" attr.aria-label="Delete Rule {{rule.name}}" (click)="confirmDelete(rule, false)">
                <svg-icon icon="icon-trash" class="tiny" [ngClass]="{'white' : selectedRule == rule}" aria-hidden="true"></svg-icon>
              </button>
            </li>
          }
        </ul>
      </section>
    }
    @if (editActive) {
      <div>
        <hr />
        <h4>Editing Rule: {{ruleName}}</h4>
        @if (showExistingRuleWarning) {
          <p>A rule of the selected type already exists on the current button.  The existing rule must be edited instead of creating a new rule.</p>
        }
        <div>
          <label>
            <span class="label-text required">Rule Name:</span>
            <input type="text" id="btnRuleName" placeholder="Name" [(ngModel)]="ruleName" />
          </label>
        </div>
        @if (editButtonMode) {
          <div>
            <label>
              <span class="label-text">Effect of Rule on Button:</span>
              <select id="slctBtnRuleOption" (ngModelChange)="updateButtonEffect($event)" [(ngModel)]="selectedButtonRuleOption">
                @for (rule of buttonRuleOptions; track rule) {
                  <option [value]="rule.id">{{rule.text}}</option>
                }
              </select>
            </label>
          </div>
        }
      </div>
    }
  </div>
}

@if (editActive) {
  <div>
    <a class="float-right">Expression Help</a>
    <label for="txarLogicExpression" class="label-text display-inline-block">Logic Expression:</label>
    <textarea id="txarLogicExpression" [(ngModel)]="expression" (ngModelChange)="expressionChanged($event)"></textarea>
    <button class="button hollow" (click)="testExpression($event)">Test Expression</button>
    <span id="evaluation" class="float-right" [ngClass]="{'compile-alert': expressionEvaluation == expressionNoCompile, 'compile-success': expressionEvaluation == expressionCompiles}">{{expressionEvaluation}}</span>
    @if (!isButtonRule) {
      <div>
        <div >
          <span class="label-text required">Action:</span>
          <select id="slctResultAction" (ngModelChange)="updateAction($event)" [(ngModel)]="selectedActionOption">
            @for (action of ruleActionOptions ; track action) {
              <option [value]="action.id">{{action.text}}</option>
            }
          </select>
        </div>
        @if (selectedActionOption !== '-1' && selectedTriggerOption === '0') {
          <div id="slctQuestionContainer">
            <label>
              <span class="label-text">Select Section:</span>
              <select id="slctSection" (ngModelChange)="changeTargetSection($event)" [(ngModel)]="targetSection">
                @for (section of availableSections; track section; let i = $index) {
                  <option [ngValue]="section">{{getSectionTitle(i, section)}}</option>
                }
              </select>
              <span class="label-text">Select Page:</span>
              <select id="slctPage" (ngModelChange)="changeTargetPage($event)" [(ngModel)]="selectedPage">
                @for (page of availablePages; track page) {
                  <option [ngValue]="page">{{getPageTitle(page)}}</option>
                }
              </select>
              <span>
                @switch (selectedActionOption) {
                  @case (0) {
                    <span>Question to enable:</span>
                  }
                  @case (1) {
                    <span>Question which updates the context</span>
                  }
                  @case (2) {
                    <span>Question to show:</span>
                  }
                }
              </span>
              <select id="slctHideQuestion" [(ngModel)]="selectedQuestion">
                @for (question of availableQuestions; track question) {
                  <option [ngValue]="question">{{getQuestionLabel(question)}}</option>
                }
              </select>
            </label>
          </div>
        }
        @if (selectedActionOption === '1') {
          <div class="cell small-12" id="txarContextValuesContainer">
            <label for="txarContextValues">
              <span class="label-text">Context Values:</span><a class="float-right">View Context Values</a>
            </label>
            <textarea id="txarContextValues" [(ngModel)]="contextTarget"></textarea>
          </div>
        }
        <div class="form-button-group">
          <button class="button hollow" [disabled]="!expressionCompiled" (disabledChange)="expressionCompiled = $event" (click)="addRule($event)">Save</button>
          <button class="button hollow" (click)="closeClick($event)">Cancel</button>
        </div>
      </div>
    }
    @if (isButtonRule) {
      <div id="buttonRulesEditorBottom">
        <div class="form-button-group">
          <button class="button hollow" [(disabled)]="disableAddRuleButton" (click)="addButtonRule($event)">Save</button>
          <button class="button hollow" (click)="closeClick($event)">Cancel</button>
        </div>
      </div>
    }
    @if (!expressionCompiled) {
      <p>Rule expressions must be compiled before they can be saved.</p>
    }
  </div>
}

